import * as actions from './productionStage/actions'
import * as mutations from './productionStage/mutations'
import * as getters from './productionStage/getters'

import { dataProps } from './productionStage/properties'

const state = {
    list: [],
    all_list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/productionStage.js